import Vue from 'vue';
export default Vue.extend({
    props: {
        transition: {
            type: String,
            default: null
        },
        collapsed: {
            type: Boolean,
            default: true
        }
    },
    data: function () {
        return {
            isOpen: !this.collapsed
        };
    },
    methods: {
        toggle: function () {
            if (this.isOpen) {
                this.$emit('collapsed');
                this.isOpen = false;
            }
            else {
                this.$emit('opened');
                this.isOpen = true;
            }
            this.$emit('update:collapsed', !this.isOpen);
            this.$emit('toggled', this.isOpen);
        }
    }
});
